import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.328 11.018h3.074c-.426.951-.704 2.033-.825 3.152a6.01 6.01 0 0 0-4.392 4.345C3.981 19.318 4.672 20 5.5 20h9c.828 0 1.52-.682 1.315-1.485a6.005 6.005 0 0 0-5.235-4.487 7.025 7.025 0 0 1 1.896-4.058l3.133-.648c1.897-.4 3.294-1.797 3.593-3.593l.799-4.491A1.7 1.7 0 0 0 19.849.5a.784.784 0 0 0-.413-.4c-.246-.1-.515-.132-.733-.06l-4.59 1.597c-1.897.599-3.095 2.295-3.095 4.192v2.794l-.2.22-.598-2.815c-.4-1.896-1.996-3.293-3.992-3.693l-5.09-.798c-.362-.047-.699 0-.899.3-.2.299-.299.698-.2.997l1.698 4.99a4.869 4.869 0 0 0 4.59 3.194zm8.283-7.485l3.094-.998-.599 2.795a2.564 2.564 0 0 1-1.996 1.996l-2.195.499V5.829c0-.998.698-1.996 1.696-2.296zM3.633 7.226L2.535 3.833l3.393.499c1.198.2 2.196 1.097 2.396 2.195l.399 2.495H6.328c-1.198 0-2.296-.698-2.695-1.796z"
});

var SvgCapitalMajor = function SvgCapitalMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCapitalMajor as S };
